import { SearchSettingsResource } from '@mode/shared/data-access-algolia';
import { createAction, props } from '@ngrx/store';

export const loadAlgoliaSearchSettings = createAction('[AlgoliaSearch] Load Settings');

export const loadAlgoliaSearchSettingsSuccess = createAction(
  '[AlgoliaSearch/API] Load Settings Success',
  props<{ settings: SearchSettingsResource['settings'] }>()
);

export const loadAlgoliaSearchSettingsFailure = createAction(
  '[AlgoliaSearch/API] Load Settings Failure',
  props<{ error: any }>()
);
